import { useTranslation } from 'react-i18next';

const hashrateImg = 'http://geel.fp.08wx.cn/images/f4a4ebfb12b9accc7702eb0f92c57ccd.jpg';

type LocaleKey = 'zh-CN' | 'en' | 'zh-TW';

const COPY = {
  'zh-CN': {
    badge: 'Hashrate Packages',
    title1: '灵活算力套餐',
    title2: '从入门到机构，全覆盖',
    desc: '提供 BTC、LTC、DOGE、KAS 等主流币种云算力，套餐周期灵活，最低 180 天起，支持随时加购或升级，收益每日自动结算至账户钱包。',
    otherCoinsTitle: '其他币种算力',
    minSellPrefix: '起售',
    cardTitle: '算力套餐',
    cardMeta: '100 EH/s · 99.8% 在线保证',
    statRows: [
      { label: 'BTC 当前挖矿难度', val: '108.52 T', change: '+2.3%' },
      { label: '全网算力', val: '768 EH/s', change: '+1.8%' },
      { label: '出块奖励', val: '3.125 BTC', change: '已减半' },
      { label: '平均出块时间', val: '9.8 min', change: '正常' },
    ],
    packages: [
      { name: '入门套餐', hashrate: '10 TH/s', coin: 'BTC', period: '180 天', price: '$299', estDaily: '~$1.2/天', color: '#FF2D78', features: ['实时收益查看', '每日自动结算', '7×24 监控', '基础客服支持'], tag: '' },
      { name: '专业套餐', hashrate: '100 TH/s', coin: 'BTC', period: '365 天', price: '$2,499', estDaily: '~$11/天', color: '#FF8C42', features: ['专属收益报表', '优先客服通道', '智能难度调整', '免维护费'], tag: '热门' },
      { name: '机构套餐', hashrate: '1 PH/s', coin: 'BTC', period: '定制', price: '定制报价', estDaily: '~$110/天', color: '#FF2D78', features: ['专属机架托管', 'API 数据接口', '对冲策略支持', '法务合规协助'], tag: '推荐' },
    ],
    altcoins: [
      { coin: 'Litecoin', algo: 'Scrypt', unit: 'GH/s', minEntry: '100 GH/s' },
      { coin: 'Dogecoin', algo: 'Scrypt', unit: 'GH/s', minEntry: '100 GH/s' },
      { coin: 'Kaspa', algo: 'kHeavyHash', unit: 'TH/s', minEntry: '1 TH/s' },
      { coin: 'Ethereum Classic', algo: 'ETHash', unit: 'GH/s', minEntry: '50 GH/s' },
    ],
  },
  en: {
    badge: 'Hashrate Packages',
    title1: 'Flexible Hashrate Plans',
    title2: 'From Starter to Institutional Scale',
    desc: 'Cloud hashrate services for major assets including BTC, LTC, DOGE, and KAS. Flexible terms starting from 180 days, with upgrades anytime and daily automatic reward settlement to your wallet.',
    otherCoinsTitle: 'Other Coin Hashrate',
    minSellPrefix: 'Starting At',
    cardTitle: 'Hashrate Plans',
    cardMeta: '100 EH/s · 99.8% Uptime Guarantee',
    statRows: [
      { label: 'Current BTC Mining Difficulty', val: '108.52 T', change: '+2.3%' },
      { label: 'Network Hashrate', val: '768 EH/s', change: '+1.8%' },
      { label: 'Block Reward', val: '3.125 BTC', change: 'Post-Halving' },
      { label: 'Average Block Time', val: '9.8 min', change: 'Normal' },
    ],
    packages: [
      { name: 'Starter Plan', hashrate: '10 TH/s', coin: 'BTC', period: '180 Days', price: '$299', estDaily: '~$1.2/day', color: '#FF2D78', features: ['Real-time earnings view', 'Daily auto settlement', '24/7 monitoring', 'Standard support'], tag: '' },
      { name: 'Pro Plan', hashrate: '100 TH/s', coin: 'BTC', period: '365 Days', price: '$2,499', estDaily: '~$11/day', color: '#FF8C42', features: ['Dedicated earning reports', 'Priority support', 'Smart difficulty tuning', 'No maintenance fee'], tag: 'Popular' },
      { name: 'Institutional Plan', hashrate: '1 PH/s', coin: 'BTC', period: 'Custom', price: 'Custom Quote', estDaily: '~$110/day', color: '#FF2D78', features: ['Dedicated rack colocation', 'API data access', 'Hedging strategy support', 'Legal & compliance assistance'], tag: 'Recommended' },
    ],
    altcoins: [
      { coin: 'Litecoin', algo: 'Scrypt', unit: 'GH/s', minEntry: '100 GH/s' },
      { coin: 'Dogecoin', algo: 'Scrypt', unit: 'GH/s', minEntry: '100 GH/s' },
      { coin: 'Kaspa', algo: 'kHeavyHash', unit: 'TH/s', minEntry: '1 TH/s' },
      { coin: 'Ethereum Classic', algo: 'ETHash', unit: 'GH/s', minEntry: '50 GH/s' },
    ],
  },
  'zh-TW': {
    badge: 'Hashrate Packages',
    title1: '靈活算力方案',
    title2: '從入門到機構，全覆蓋',
    desc: '提供 BTC、LTC、DOGE、KAS 等主流幣種雲算力，方案週期靈活，最低 180 天起，支援隨時加購或升級，收益每日自動結算至帳戶錢包。',
    otherCoinsTitle: '其他幣種算力',
    minSellPrefix: '起售',
    cardTitle: '算力方案',
    cardMeta: '100 EH/s · 99.8% 在線保障',
    statRows: [
      { label: 'BTC 目前挖礦難度', val: '108.52 T', change: '+2.3%' },
      { label: '全網算力', val: '768 EH/s', change: '+1.8%' },
      { label: '出塊獎勵', val: '3.125 BTC', change: '已減半' },
      { label: '平均出塊時間', val: '9.8 min', change: '正常' },
    ],
    packages: [
      { name: '入門方案', hashrate: '10 TH/s', coin: 'BTC', period: '180 天', price: '$299', estDaily: '~$1.2/天', color: '#FF2D78', features: ['即時收益查看', '每日自動結算', '7×24 監控', '基礎客服支援'], tag: '' },
      { name: '專業方案', hashrate: '100 TH/s', coin: 'BTC', period: '365 天', price: '$2,499', estDaily: '~$11/天', color: '#FF8C42', features: ['專屬收益報表', '優先客服通道', '智慧難度調整', '免維護費'], tag: '熱門' },
      { name: '機構方案', hashrate: '1 PH/s', coin: 'BTC', period: '客製', price: '客製報價', estDaily: '~$110/天', color: '#FF2D78', features: ['專屬機架託管', 'API 數據介面', '對沖策略支援', '法務合規協助'], tag: '推薦' },
    ],
    altcoins: [
      { coin: 'Litecoin', algo: 'Scrypt', unit: 'GH/s', minEntry: '100 GH/s' },
      { coin: 'Dogecoin', algo: 'Scrypt', unit: 'GH/s', minEntry: '100 GH/s' },
      { coin: 'Kaspa', algo: 'kHeavyHash', unit: 'TH/s', minEntry: '1 TH/s' },
      { coin: 'Ethereum Classic', algo: 'ETHash', unit: 'GH/s', minEntry: '50 GH/s' },
    ],
  },
};

export default function MiningHashrateSection() {
  const { i18n } = useTranslation();
  const lang = (i18n.resolvedLanguage || i18n.language || 'zh-CN').toLowerCase();
  const locale: LocaleKey = lang.startsWith('zh-tw') || lang.startsWith('zh-hk') ? 'zh-TW' : lang.startsWith('en') ? 'en' : 'zh-CN';
  const copy = COPY[locale];

  return (
    <section id="hashrate" className="bg-white py-24">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="flex flex-col lg:flex-row gap-14 xl:gap-20">
          <div className="flex-1 min-w-0">
            <div className="inline-flex items-center gap-2 mb-6 px-3 py-1.5 bg-primary/10 border border-primary/20 rounded-full">
              <i className="ri-cpu-line text-primary text-xs" />
              <span className="text-primary text-xs font-medium uppercase tracking-widest">{copy.badge}</span>
            </div>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-gray-900 mb-4 leading-tight">
              {copy.title1}
              <br />
              <span className="text-primary">{copy.title2}</span>
            </h2>
            <p className="text-gray-500 text-base leading-relaxed mb-8">{copy.desc}</p>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-10">
              {copy.packages.map((pkg, i) => (
                <div key={i} className="bg-light-alt border border-primary/10 rounded-2xl p-5 hover:border-primary/25 transition-all duration-200 relative">
                  {pkg.tag && (
                    <div className="absolute top-3 right-3 text-xs px-2 py-0.5 rounded-full font-medium" style={{ background: `${pkg.color}15`, color: pkg.color, border: `1px solid ${pkg.color}25` }}>
                      {pkg.tag}
                    </div>
                  )}
                  <div className="mb-4">
                    <div className="text-gray-800 font-heading font-bold text-base mb-1">{pkg.name}</div>
                    <div className="text-3xl font-heading font-black" style={{ color: pkg.color }}>{pkg.hashrate}</div>
                    <div className="text-xs text-gray-400">{pkg.coin} · {pkg.period}</div>
                  </div>
                  <div className="mb-4 pb-4 border-b border-primary/10">
                    <div className="text-xl font-heading font-bold text-gray-900">{pkg.price}</div>
                    <div className="text-xs text-gray-400">{pkg.estDaily}</div>
                  </div>
                  <ul className="space-y-1.5 mb-4">
                    {pkg.features.map((f, j) => (
                      <li key={j} className="flex items-center gap-2 text-xs text-gray-500">
                        <i className="ri-check-line text-primary text-xs" />
                        {f}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>

            <div className="bg-light-alt border border-primary/10 rounded-xl overflow-hidden">
              <div className="px-5 py-3 border-b border-primary/10 bg-primary/5">
                <span className="text-xs font-medium text-gray-400 uppercase tracking-wider">{copy.otherCoinsTitle}</span>
              </div>
              <div className="grid grid-cols-2 sm:grid-cols-4">
                {copy.altcoins.map((c, i) => (
                  <div key={i} className={`px-5 py-4 ${i < 2 ? 'border-b sm:border-b-0' : ''} border-primary/10 ${i % 4 !== 3 ? 'border-r' : ''}`}>
                    <div className="text-gray-800 text-sm font-medium mb-1">{c.coin}</div>
                    <div className="text-gray-400 text-xs">{c.algo}</div>
                    <div className="text-primary text-xs mt-1">{copy.minSellPrefix} {c.minEntry}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="lg:w-[380px] xl:w-[440px] flex-shrink-0">
            <div className="relative rounded-2xl overflow-hidden border border-primary/15 sticky top-24">
              <div className="w-full h-[300px]">
                <img src={hashrateImg} alt="Hashrate Packages" className="w-full h-full object-cover object-top" />
                <div className="absolute inset-0 bg-gradient-to-t from-white/60 via-transparent to-transparent" />
              </div>
              <div className="absolute top-4 left-4 bg-white/95 border border-primary/20 rounded-xl px-4 py-3 backdrop-blur-sm">
                <div className="flex items-center gap-2 mb-1">
                  <i className="ri-cpu-line text-primary text-sm" />
                  <span className="text-gray-800 text-xs font-medium">{copy.cardTitle}</span>
                </div>
                <div className="text-gray-400 text-xs">{copy.cardMeta}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
